<template>
  <div class="farms-tab">
    <v-progress-linear class="loading" v-show="loading" :indeterminate="true"></v-progress-linear>
    <search-input :search="this.search" placeholder="Search" @on-search="handleSearch"></search-input>
    <div v-show="!loading" class="total-ctn">{{farmCount}} {{ farmCount ? 'farms' : 'farm' }} found.</div>
    <list v-show="!loading">
      <list-item v-for="farm in farmList" @handle-click="handleClick(farm)" :key="farm.id" :selected="selectedFarm.id == farm.id" slot="item">
        <farm-item :farm="farm">
        </farm-item>
      </list-item>
      <info-card v-show="this.selectedFarm.id" slot="info-card">
        <farm-card :farm="this.selectedFarm"></farm-card>
      </info-card>
    </list>
  </div>
</template>

<script>

import List from '@/components/List'
import ListItem from '@/components/ListItem'
import InfoCard from '@/components/InfoCard'

import FarmItem from '@/components/FarmItem'
import FarmCard from '@/components/FarmCard'

import SearchInput from '@/components/SearchInput'

import { mapGetters } from 'vuex'

export default {
  name: 'FarmsTab',
  components: {
    'list': List,
    'list-item': ListItem,
    'farm-item': FarmItem,
    'info-card': InfoCard,
    'farm-card': FarmCard,
    'search-input': SearchInput
  },
  computed: mapGetters({
    selectedFarm: 'selectedFarm',
    farmList: 'filteredFarms',
    loading: 'farmLoading',
    farmCount: 'farmCount'
  }),
  data () {
    return {
      search: ''
    }
  },
  methods: {
    handleClick (farm) {
      this.$store.dispatch('selectFarm', { farm: farm })
    },
    handleSearch (search) {
      this.$store.dispatch('clearFarmSelection')
      this.$store.dispatch('searchFarm', search)
    }
  },
  created () {
    this.$store.dispatch('loadFarmList')
    this.$store.dispatch('loadCertificates')
  }
}

</script>

<style lang="scss" scoped>

.farms-tab{
  position: relative;
}

.loading{
  position: absolute;
  margin-top: 0px;
  top: 0px;
}

.farms-tab{
  padding: 0px;
  background: white;
}

.total-ctn{
  padding-left: 16px;
  padding-top: 15px;
  font-size: 15px;
  font-weight: bold;
}

</style>
